module.exports = __webpack_public_path__ + "img/Group15.8b1f56b1.png";